// extracted by mini-css-extract-plugin
module.exports = {"mapInformation":"mapInformation_mapInformation__28QaJ","tableWrap":"mapInformation_tableWrap__3vkPa","rightBorder":"mapInformation_rightBorder__FBeRa"};